import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Injectable()
export class DevelopmentGuard implements CanActivate {

    canActivate() {
        return !environment.production;
    }
}
